import { Viaje } from "./Viaje";
import { ViajeVisita } from "./ViajeVisita";
import { Visita } from "./Visita";
import { VisitaTarea } from "./VisitaTarea";
import { ViajeVista } from "./ViajeVista";
export class ViajeContenedor {


    public visita: Visita= new Visita();
    public viajeVisita: ViajeVisita[];
    public viaje: Viaje= new Viaje(); 
    public visitaTarea: VisitaTarea[];
}